export default __webpack_public_path__ + "static/media/ellipse.91eae4f5.svg";